export default __webpack_public_path__ + "static/media/3-cassettes-open-3-left.08fed660.svg";